export default __webpack_public_path__ + "static/simple-area-2d8dbc17f50bb118ad391766e676e7c7.png";